import { render, staticRenderFns } from "./Help.vue?vue&type=template&id=22c31aaa&scoped=true"
import script from "./Help.vue?vue&type=script&lang=js"
export * from "./Help.vue?vue&type=script&lang=js"
import style0 from "./Help.vue?vue&type=style&index=0&id=22c31aaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c31aaa",
  null
  
)

export default component.exports